module.exports = __webpack_public_path__ + "static/OtpGeoSms-07a909af4ce61d44e76568724fafc8d9.png";